module.exports = __webpack_public_path__ + "img/installing_into_wall_w_wedge_non_wired.6d253ce8.png";